import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.some";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import _defineProperty from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import { format } from '@tencent/vft-utils';
import { mapState } from 'vuex';
import Storage from '@tencent/vft-common/Storage';
var KEY = 'vftYSFShowReceiveHistoryTime';
export default {
  components: {
    SvgIcons: SvgIcons,
    Avatar: Avatar
  },
  data: function data() {
    return {
      showHistoryTime: Storage.get(KEY)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['buyList'])), {}, {
    // activity_name 和 活动名称的对应关系
    activityNameMap: function activityNameMap() {
      return this.setting.演出场次.reduce(function (total, cur) {
        return Object.assign(total, _defineProperty({}, cur.activity_name, cur.名称));
      }, {});
    },
    // 对数据进行过滤
    otherBuyList: function otherBuyList() {
      var _this = this;

      return Object.keys(this.buyList).map(function (key) {
        var list = _this.buyList[key] || [];
        return {
          key: key,
          name: _this.activityNameMap[key],
          list: _this.filterBuyList(list)
        };
      });
    },
    // 新领取的用户
    diffUserList: function diffUserList() {
      var _this2 = this;

      var list = this.otherBuyList.map(function (v) {
        var curOrder = v.list[0];
        if (!curOrder) return [];

        if (!_this2.showHistoryTime) {
          return v.list[0].list;
        }

        return (v.list[0].list || []).filter(function (item) {
          return +item.vuid !== +_this2.userService.vuid && item.time * 1000 > _this2.showHistoryTime;
        }) || [];
      });
      return list.reduce(function (prev, cur) {
        return prev.concat(cur);
      }, []);
    },
    // 是否有买票数据
    isHasData: function isHasData() {
      return this.otherBuyList.some(function (v) {
        return v.list.length > 0;
      });
    },
    // 显示买赠票模块
    // 将 name、key 填充到数组的item中，对数组进行排序
    showBuyList: function showBuyList() {
      var list = this.otherBuyList.map(function (item) {
        return item.list.map(function (val) {
          return _objectSpread({
            name: item.name,
            key: item.key
          }, val);
        });
      });
      return list.reduce(function (prev, cur) {
        return prev.concat(cur);
      }, []).sort(function (a, b) {
        return b.lCreatTime - a.lCreatTime;
      });
    }
  }),
  watch: {
    diffUserList: function diffUserList(val) {
      if (val && val.length) {
        Storage.set(KEY, Date.now());
        this.showHistoryTime = Date.now();
        this.eventBus.$emit('showReceive', val);
      }
    }
  },
  filters: {
    // 格式化时间戳
    formatDate: function formatDate(value) {
      return format(value, 'Y-MM-dd');
    }
  },
  methods: {
    filterBuyList: function filterBuyList() {
      var _this3 = this;

      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (list.filter(function (item) {
        return !item.bBuyForYourself || item.iTicketNum > 1;
      }) || []).map(function (item) {
        return item.bBuyForYourself ? _objectSpread(_objectSpread({}, item), {}, {
          iTicketNum: item.iTicketNum - 1,
          iHasGotNum: item.iHasGotNum - 1,
          list: (item.list || []).filter(function (val) {
            return +val.vuid !== +_this3.userService.vuid;
          }) // 去掉自己的

        }) : _objectSpread(_objectSpread({}, item), {}, {
          list: item.list || []
        });
      });
    }
  }
};